import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "loginpanel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Input")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("List")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Graph")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Tools")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("SignOut")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_authenticator = _resolveComponent("authenticator")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createVNode(_component_authenticator, { "hide-sign-up": _ctx.hideSignup }, null, 8, ["hide-sign-up"])
    ]),
    (_ctx.auth.route === 'authenticated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_menu, {
            "default-active": _ctx.activeIndex,
            ellipsis: false,
            class: "el-menu-navi",
            mode: "horizontal",
            onSelect: _ctx.onPageSelect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, {
                label: "Input",
                name: "input",
                index: "1"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                label: "List",
                name: "list",
                index: "2"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                label: "Graph",
                name: "graph",
                index: "3"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                label: "Tools",
                name: "tools",
                index: "4"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _hoisted_7,
              _createVNode(_component_el_menu_item, {
                label: "SignOut",
                name: "signout",
                index: "5"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active", "onSelect"]),
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}